<template>
  <div>
    <section id="top" class="relative not_found">
      <div id="top_content">
        <div id="teaset_text" class="center">
          <div>
            <h2>{{ $t('not_found_title') }}
            </h2>
          </div>
          <div class="mid_size_text_block">{{ $t('not_found_content') }}</div>
          <div id="teaser_button" class="center">
            <router-link id="top_get_started" to="/" class="btn btn_big btn_filled btn_blue">{{ $t('not_found_btn') }}</router-link>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

export default {
  props: {
    options: {
      type: Object
    }
  },
  components: {},
  data() {
    return {};
  },
  created() {
  },
  beforeRouteLeave(req, res, next) {
    next();
  },
  methods: {},
  mounted() {
    if(this.options.currentRoute != 'Brandings'){
      this.options.showBrandForm = false;
    }
  }
};
</script>